import { useEffect } from 'react';
import { paths } from 'src/common/config/TextMessage';

/** Routes on which the Intercom launcher bubble should be visible. */
const INTERCOM_VISIBLE_PATHS = new Set([
  paths.siteAudit,
  paths.settings,
  paths.billing,
  paths.externalScans,
  paths.userManagement,
  paths.seoTasks,
  paths.keywordResearch,
  paths.leadGeneration,
  paths.keywordOverview,
  paths.competitorAnalysis,
  paths.blogPostIdeas,
  paths.onBoarding,
  paths.statusCheck,
  paths.dashboard,
  paths.keywordTracking,
  paths.otherTools,         // '/local-seo'
  '/other-tools',           // legacy path
  '/other-tools/backlinks',
  '/other-tools/local-seo-tools',
  paths.keywordsLists,
  paths.backlinkPage,
  paths.localChecker,
  paths.googleBusiness,
  paths.mapRankTracker,
  paths.localTasks,
  paths.googleReviews,
  paths.businessPosts,
  paths.listingManager,
  paths.aiVisibility
]);

/**
 * Shows or hides the Intercom launcher bubble based on the current route.
 * A 1-second delay is applied to allow the widget to mount before being toggled.
 *
 * @param pathname - Current `location.pathname` from `useLocation()`.
 */
export const useIntercomVisibility = (pathname: string) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      const widget = document.querySelector<HTMLElement>('.intercom-launcher');
      if (!widget) return;
      widget.style.visibility = INTERCOM_VISIBLE_PATHS.has(pathname) ? 'inherit' : 'hidden';
    }, 1000);

    return () => clearTimeout(timer);
  }, [pathname]);
};
